import { render, staticRenderFns } from "./AssignedProductRow.vue?vue&type=template&id=3ca22b30"
import script from "./AssignedProductRow.vue?vue&type=script&lang=js"
export * from "./AssignedProductRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports